import { createSlice } from "@reduxjs/toolkit";
import stringUtils from "../../../../../../_services/string-utils";
import { InitialIntegrationReducer } from "../../../../../_services/store/InitialIntegrationReducer";
import { integrationReducerActions } from "../../../../../_commons/integration.reducer";

export const initialNewConfiguration = {
    clientUUID: "",
    connectedToAmazonPay: false,
    useExistingSettingsClientUUID: null,
    useExistingSettings: false,
};

export const initialDeleteConfigurationRequest = {
    externalUUID: "",
    clientUUID: "",
    deleteConnectedAuthData: false,
};

export const initialShopifyOrderReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: { ...initialNewConfiguration },
    deleteConfigurationRequest: { ...initialDeleteConfigurationRequest },
    importData: null,
    cacheResetLoading: false,
    cacheResetSuccess: false,
    cacheResetErrorMessage: null,
    cacheBackfillLoading: false,
    cacheBackfillSuccess: false,
    cacheBackfillErrorMessage: null,
};

const shopifyOrderSlice = createSlice({
    name: "ShopifyOrder",
    initialState: { ...initialShopifyOrderReducer },
    reducers: {
        ...integrationReducerActions,
        setDeleteConfigurationRequest(state, action) {
            state.deleteConfigurationRequest = action.payload;
        },
        deleteConfigurationRequest(state) {
            state.isDeleteLoading = true;
            state.deleteErrorMessage = null;
            state.successMessage = null;
        },
        deleteConfigurationSuccess(state, action) {
            state.configurations = [...state.configurations].filter(
                (configuration) => !stringUtils.equals(configuration.externalUUID, action.payload.externalUUID)
            );
            state.configurationToBeDeleted = null;
            state.deleteConfigurationModal = false;
            state.isDeleteLoading = false;
            state.successMessage = "Integration gelöscht";
        },
        deleteConfigurationFailure(state, action) {
            state.isDeleteLoading = false;
            state.deleteErrorMessage = action.payload;
        },

        resetEditConfigurationToConfiguration(state) {
            state.editConfiguration = state.configuration;
        },

        startPreImportRequest(state) {
            state.importData = null;
            state.isImportLoading = true;
            state.importErrorMessage = null;
            state.importSuccessMessage = null;
            state.updateErrorMessage = null;
        },
        startPreImportSuccess(state, action) {
            state.importData = action.payload;
            state.isImportLoading = false;
        },
        startPreImportFailure(state, action) {
            state.importData = null;
            state.isImportLoading = false;
            state.importErrorMessage = action.payload;
        },

        startFullImportRequest(state) {
            state.isImportLoading = true;
            state.importData = null;
            state.importSuccessMessage = null;
            state.importErrorMessage = null;
        },
        startFullImportSuccess(state) {
            state.isImportLoading = false;
            state.importSuccessMessage =
                "Buchungsstapel wird erzeugt, Du erhältst eine E-Mail wenn der Abruf abgeschlossen ist.";
        },
        startFullImportFailure(state, action) {
            state.isImportLoading = false;
            state.importErrorMessage = action.payload;
        },

        validateAppstoreAccessScopesRequest(state) {
            state.isLoading = true;
        },

        validateAppstoreAccessScopesSuccess(state, action) {
            state.isLoading = false;
            state.successMessage = action.payload;
        },

        validateAppstoreAccessScopesFailure(state, action) {
            state.isLoading = false;
            state.importErrorMessage = action.payload;
        },

        setSubmitted(state, action) {
            state.submitted = action.payload;
        },

        resetSuccessMessages(state) {
            state.successMessage = null;
        },
        resetUpdateErrorMessage(state) {
            state.updateErrorMessage = null;
        },
        startPrepaymentReportRequest(state) {
            state.isImportLoading = true;
            state.prepaymentImportSuccessMessage = null;
            state.prepaymentImportErrorMessage = null;
        },
        startPrepaymentReportSuccess(state) {
            state.isImportLoading = false;
            state.prepaymentImportSuccessMessage =
                "Der Erhaltene-Anzahlungen Bericht wird derzeit erstellt und steht nach Fertigstellung zum Download bereit.";
        },
        startPrepaymentReportFailure(state, action) {
            state.isImportLoading = false;
            state.prepaymentImportErrorMessage = action.payload;
        },
        startAsyncV2ShopifyImportRequest(state) {
            state.isImportLoading = true;
            state.importData = null;
            state.importSuccessMessage = null;
            state.importErrorMessage = null;
        },
        startAsyncV2ShopifyImportSuccess(state) {
            state.isImportLoading = false;
            state.importSuccessMessage =
                "Buchungsstapel wird erzeugt, Du erhältst eine E-Mail wenn der Abruf abgeschlossen ist.";
        },

        startAsyncV2ShopifyImportFailure(state, action) {
            state.isImportLoading = false;
            state.importErrorMessage = action.payload;
        },
        fetchShopifyV2CatchUpStatusRequest(state) {
            state.catchUpStatusLoading = true;
            state.catchUpStatusPayload = null;
            state.catchUpStatusErrorMessage = null;
        },
        fetchShopifyV2CatchUpStatusSuccess(state, action) {
            state.catchUpStatusLoading = false;
            state.catchUpStatusPayload = action.payload;
            state.catchUpStatusErrorMessage = null;
        },
        fetchShopifyV2CatchUpStatusFailure(state, action) {
            state.catchUpStatusLoading = false;
            state.catchUpStatusPayload = null;
            state.catchUpStatusErrorMessage = action.payload;
        },
        resetCacheRequest(state) {
            state.cacheResetLoading = true;
            state.cacheResetSuccess = false;
            state.cacheResetErrorMessage = null;
        },
        resetCacheSuccess(state) {
            state.cacheResetLoading = false;
            state.cacheResetSuccess = true;
            state.cacheResetErrorMessage = null;
        },
        resetCacheFailure(state, action) {
            state.cacheResetLoading = false;
            state.cacheResetSuccess = false;
            state.cacheResetErrorMessage = action.payload;
        },
        backfillCacheRequest(state) {
            state.cacheBackfillLoading = true;
            state.cacheBackfillSuccess = false;
            state.cacheBackfillErrorMessage = null;
        },
        backfillCacheSuccess(state) {
            state.cacheBackfillLoading = false;
            state.cacheBackfillSuccess = true;
            state.cacheBackfillErrorMessage = null;
        },
        backfillCacheFailure(state, action) {
            state.cacheBackfillLoading = false;
            state.cacheBackfillSuccess = false;
            state.cacheBackfillErrorMessage = action.payload;
        },
        // issue-5703: override the shared toggle so opening the Advanced Settings modal does not
        // discard in-progress edits made outside the modal (e.g. the US VAT Liability account in
        // the accounting rules screen). Cancel is handled explicitly by cancelAdvancedSettingsModal
        // which reverts editConfiguration via setEditConfiguration(configuration) before toggling.
        toggleAdvancedSettingsModal(state) {
            state.advancedSettingsModal = !state.advancedSettingsModal;
            state.successMessage = null;
        },
    },
});

export default shopifyOrderSlice;
